import AllGroupsTransactions from 'containers/Groups/Transactions';

export default {
  exact: true,
  name: 'All Transactions',
  protected: true,
  path: '/all-transactions',
  component: AllGroupsTransactions,
  permissions: ['all'],
};
